export const STATUS_OPTIONS = [
  { value: "offen", label: "Offen" },
  { value: "bezahlt", label: "Bezahlt" },
  { value: "teilbezahlt", label: "Teilbezahlt" },
  { value: "ueberfaellig", label: "Überfällig" },
];

export const STATUS_LABELS = STATUS_OPTIONS.reduce((a, s) => ({ ...a, [s.value]: s.label }), {});

export const STATUS_STYLES = {
  offen: "bg-slate-100 text-slate-700 border-slate-300",
  bezahlt: "bg-green-50 text-green-800 border-green-300",
  ueberfaellig: "bg-red-50 text-red-800 border-red-300",
  teilbezahlt: "bg-amber-50 text-amber-800 border-amber-300",
};

export const TEMPLATES = [
  { value: "modern", label: "Modern", desc: "Farbige Kopfzeile, kräftige Tabelle" },
  { value: "classic", label: "Klassisch", desc: "Schlicht, S/W, zentrierter Titel" },
];

export const VAT_RATES = [19, 7, 0];
export const UNITS = ["Stk.", "Std.", "Tag(e)", "Pauschal", "km", "m²", "kg", "l", "Monat(e)"];

export function formatEUR(v) {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(v || 0));
}

export function formatNum(v, digits = 2) {
  return new Intl.NumberFormat("de-DE", { maximumFractionDigits: digits }).format(Number(v || 0));
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("de-DE");
}

export function computeTotals(items, klein) {
  let net = 0;
  const groups = {};
  (items || []).forEach((it) => {
    const line = (Number(it.quantity) || 0) * (Number(it.unit_price) || 0);
    net += line;
    if (!klein) {
      const r = Number(it.vat_rate) || 0;
      groups[r] = (groups[r] || 0) + (line * r) / 100;
    }
  });
  const vat = Object.values(groups).reduce((a, b) => a + b, 0);
  return { net, groups, vat, gross: net + vat };
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysISO(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}
